import {
  addFolderImages,
  deleteFolderImages,
  getFolderImages,
} from "../../../..//services/folder";
import { DeleteFilled, UploadOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Modal, Upload, notification } from "antd";
import React, { useEffect, useState } from "react";
import { useHistory, Link, useParams, useLocation } from "react-router-dom";
import styles from "./styles.css";
const UploadFolderImages = ({ dispatch }) => {
  const [images, setImages] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [modal, setModal] = useState(false);
  const { folderId } = useParams();
  const [loading, setLoading] = useState(false);
  const [onPreview, setOnPreview] = useState("");
  const [viewSize, setViewSize] = useState(10);
  const [startIndex, setStartIndex] = useState(0);
  const [deleteImages, setDeleteImages] = useState([]);
  const getFolderFun = () => {
    getFolderImages({
      pathParams: {
        folderId,
      },
      query: {
        viewSize,
        startIndex,
      },
    }).then((res) => {
      setImages(res.folder);
    });
  };
  useEffect(() => {
    getFolderFun();
  }, []);
  const addFolderFun = () => {
    setLoading(true);
    const formData = new FormData();
    fileList.map((val, idx) => {
      formData.append("uploadImage", val);
    });

    addFolderImages({
      pathParams: {
        folderId,
      },
      body: formData,
    })
      .then((res) => {
        setLoading(false);
        setModal(false);
        setImages([...res.data, ...images]);
        setFileList([]);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  function updateImage(file) {
    setFileList((prev) => [...prev, file]);
  }
  const createURL = (file) => {
    const newURL = {
      ...file,
      url: URL.createObjectURL(file),
    };
    setOnPreview(newURL.url);
  };
  return (
    <div className="w-full ">
      <div className="mx-4 sticky">
        <Breadcrumb style={{ marginBottom: 20 }}>
          <Breadcrumb.Item>
            <Link to="/dashboard">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/folder">Folder</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
        <div className="flex justify-between w-full">
          <h1 className="page-heading">Gallery</h1>
          <div className="flex">
            <button
              onClick={() => {
                setModal({
                  visible: true,
                  value: "",
                });
              }}
              className="bg-[#FA6210] h-12 px-5 font-semibold hover:bg-[#15538B]  rounded-md text-white"
            >
              Add Images
            </button>
            <div>
              {deleteImages.length > 0 ? (
                <Button
                  size="large"
                  onClick={() => {
                    setDeleteImages([]);
                  }}
                  style={{
                    backgroundColor: "#FA6210",
                    cursor: "pointer",

                    marginInline: 10,
                    color: "#fff",
                  }}
                  className=" h-12 px-5 font-semibold   rounded-md text-whitehover:bg-[#000]
                  "
                >
                  De-Select {deleteImages.length > 1 ? "All Images" : "Image"}
                </Button>
              ) : (
                <></>
              )}
              {deleteImages.length > 0 ? (
                <Button
                  size="large"
                  onClick={() => {
                    deleteFolderImages({
                      body: {
                        id: deleteImages,
                      },
                    }).then(() => {
                      getFolderFun();
                      setDeleteImages([]);
                    });
                  }}
                  style={{
                    backgroundColor: "#FA6210",
                    cursor: "pointer",
                    color: "#fff",
                  }}
                  className=" h-12 px-5 font-semibold   rounded-md text-white hover:bg-[#000]"
                >
                  Delete {deleteImages.length > 1 ? "All Images" : "Image"}
                </Button>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>

      {images.length === 0 ? (
        <div className="w-full ">
          <h3
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            No Images
          </h3>
          <p className="text-center  my-2">
            There have been no Images in this section yet
          </p>
          <div className="flex w-full justify-center">
            <Button
              onClick={() => {
                setModal({
                  visible: true,
                  value: "",
                });
              }}
            >
              Add Images
            </Button>
          </div>
        </div>
      ) : (
        <></>
      )}
      <div className="mt-10 w-full flex flex-wrap">
        {images.map((i) => {
          return (
            <div
              key={i._id}
              className="gallery"
              onClick={() => {
                if (deleteImages.includes(i.uuid)) {
                  const updateIds = deleteImages.filter((j) => j !== i.uuid);
                  setDeleteImages(updateIds);
                } else {
                  const updatedIds = [...new Set([i.uuid, ...deleteImages])];
                  setDeleteImages(updatedIds);
                }
              }}
              style={{
                position: "relative",
                cursor: "pointer",
                marginInline: 20,
                marginBlock: 10,
              }}
            >
              <img
                key={i._id}
                src={i.url}
                alt=""
                style={{
                  filter: deleteImages.includes(i.uuid)
                    ? "grayscale(100%)"
                    : "grayscale(0%)",
                  width: "160px",
                  height: "120px",
                  borderRadius: 10,
                }}
              />
            </div>
          );
        })}
      </div>

      <Modal visible={modal} footer={false} closable={false}>
        <div className="p-4">
          <Upload
            listType="picture"
            multiple={true}
            accept=".jpg, .png, .jpeg, .tiff|image/*,video/mp4,video/x-m4v,video/*"
            beforeUpload={(content) => {
              console.log("content", content);
              const isLt2M = content.size / 5000 / 5000 < 2;
              if (isLt2M) {
                content.flag = true;
                updateImage(content);
                return false;
              } else {
                notification.error({
                  message: `Can't  Upload file more then 5MB`,
                });
              }
              return false;
            }}
            onPreview={(file) => {
              createURL(file);
            }}
            fileList={[...fileList]}
            onRemove={(file) => {
              setFileList((prev) =>
                prev.filter((item) => item.uid !== file.uid)
              );
            }}
          >
            <Button size="large" icon={<UploadOutlined />}>
              Click to Upload
            </Button>
          </Upload>
          <div className="flex justify-end p-3">
            <Button
              className="mr-2 "
              onClick={() => {
                setModal(false);
              }}
            >
              Cancel
            </Button>
            <Button
              loading={loading}
              type="primary"
              onClick={() => {
                addFolderFun();
              }}
            >
              Save
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default UploadFolderImages;
